module.exports = __webpack_public_path__ + "img/p2-53.d974c69e.png";